import { call, put, takeLatest, all, select } from "redux-saga/effects";
import { api_get, PROYECT } from "services/api";
import { types } from "redux/reducers/crmReducer";
import { openSnackbar } from "redux/ducks/globalSnackbar";
import { defaultValuesCrm } from "helpers/dictionary";
import { api_put } from "services/api";
import { api_post } from "services/api";
import { sendAccountAction } from "redux/actions/crmActions";
import { convertToMap } from "helpers/convertToMap";
import { getStations } from "helpers/companiesNormalized";
import dayjs from "dayjs";

function* fetchStations(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const stationsUrl = `${process.env.REACT_APP_URL}${PROYECT}/companies`;

  try {
    const response = yield call(api_get, stationsUrl, auth);

    const stations = getStations(response.companies);

    const stationsNormalized = stations.map((station) => {
      return { value: station.id, label: station.name, ...station };
    });
    const stationsMap = convertToMap(stationsNormalized, "id");

    yield put({
      type: types.SET_STATIONS,
      payload: {
        stations: stationsNormalized,
        stationsMap,
      },
    });
  } catch (message) {
    yield put({
      type: types.ERROR_STATIONS,
    });
    yield put(openSnackbar(message, "danger"));
  }
}
function* fetchData(action) {
  const token = yield select((state) => state.login.token);
  const { phone } = action;
  const auth = { headers: { authorization: `${token}` } };
  const companiesUrl = `${process.env.REACT_APP_URL}${PROYECT}/customers?filter=${phone}`;

  try {
    const response = yield call(api_get, companiesUrl, auth);
    yield put({
      type: types.SET_CUSTOMERS,
      payload: {
        customers: response,
      },
    });
    
  } catch (message) {
    yield put({
      type: types.ERROR_CUSTOMERS,
    });
    yield put(openSnackbar(message, "danger"));
  }
}
function* fetchMenuData(action) {
  const { idAccount, idStation, type } = action.payload;
  const token = yield select((state) => state.login.token);
  const stationsMap = yield select((state) => state.companies.stationsObj);
  const authUser = { headers: { authorization: `${token}` } };
  const unitsUrl = `${process.env.REACT_APP_URL}${PROYECT}/units?stations=${idStation}`;
  const productsUrl = `${process.env.REACT_APP_URL}${PROYECT}/accounts/${idAccount}/products`;
  const schedulesUrl = `${process.env.REACT_APP_URL}${PROYECT}/stations/${idAccount}/schedules`;
  try {
    const [units, products, schedules] = yield all([
      call(api_get, unitsUrl, authUser),
      call(api_get, productsUrl, authUser),
      call(api_get, schedulesUrl, authUser),
    ]);
    const unitsNormalized = units
      .filter((unit) => unit.type === type)
      .map((unit) => {
        return {
          value: unit.id,
          label: `${stationsMap[unit.idStation].name} - ${unit.number}`,
          station: stationsMap[unit.idStation].name,
          ...unit,
        };
      });
    const productsNormalized = products.map((product) => {
      return {
        value: product.id,
        label: `${product.product}`,
        ...product,
      };
    });
    const schedulesNormalized = schedules
      .map((date) => {
        return {
          value: date.date,
          label: dayjs(date.date).format("DD/MM/YYYY"),
          schedules: date.schedules
            .map((schedule) => {
              return {
                value: schedule.id,
                label: `${schedule.start} - ${schedule.end}`,
                ...schedule,
              };
            })
          // FIXME: SE REMUEVE VALIDACION TEMPORALMENTE PARA PRUEBAS
            //.filter((schedule) => {
            //  if (Number(date.date.substring(8, 10)) === currentDay) {
            //    return Number(schedule.start.replace(":00", "")) > currentHour;
            //  } else {
            //    return true;
            //  }
            //}),
        };
      })
      .filter((date) => date.schedules.length > 0);
    yield put({
      type: types.SET_MENU_DATA,
      payload: {
        units: unitsNormalized,
        products: productsNormalized,
        schedules: schedulesNormalized,
      },
    });
  } catch (message) {
    yield put({
      type: types.ERROR_MENU_DATA,
    });
    yield put(openSnackbar(message, "danger"));
  }
}
function* fetchCustomerOrders(action) {
  const token = yield select((state) => state.login.token);
  const { id } = action;
  const authUser = { headers: { authorization: `${token}` } };
  const ordersUrl = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}/services`;
  try {
    const response = yield call(api_get, ordersUrl, authUser);
    yield put({
      type: types.SET_ORDERS,
      payload: {
        services: response,
      },
    });
  } catch (e) {
    const { data } = e.response;

    let error = "";
    if (e.response.status === 404) {
      error = "Error al enviar la petición.";
    } else {
      error = data ? data.message.error : "Error de datos";
    }

    yield put({
      type: types.ERROR_ORDERS,
    });
    yield put(openSnackbar(error, "danger"));
  }
}
function* sendCustomer(action) {
  const token = yield select((state) => state.login.token);
  const { body, isEdit, id } = action.payload;
  const auth = { headers: { authorization: `${token}` } };
  const urlPost = `${process.env.REACT_APP_URL}${PROYECT}/customers`;
  const urlPut = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}`;
  try {
    const fnForm = isEdit ? api_put : api_post;
    const url = isEdit ? urlPut : urlPost;
    const response = yield call(fnForm, url, body, auth);
    let customerResponse = isEdit ? response : response[0];
    yield put({
      type: types.SUCCESS_CUSTOMER,
      payload: {
        customer: customerResponse,
      },
    });

    const newBody = {
      ...body,
      ...defaultValuesCrm.account,
      cellphone: body.phone,
      idCustomer: customerResponse.id,
    };
    if (!isEdit) {
      yield put(sendAccountAction(newBody, false, customerResponse.id, null));
    }
    yield put(openSnackbar(`Cliente editado con éxito.`, "success"));
  } catch (message) {
    yield put({
      type: types.ERROR_CUSTOMERS,
    });
    yield put(openSnackbar(message, "danger"));
  }
}
function* sendAccount(action) {
  const token = yield select((state) => state.login.token);
  const { body, isEdit, idCustomer, idAccount } = action.payload;
  const auth = { headers: { authorization: `${token}` } };
  const urlPost = `${process.env.REACT_APP_URL}${PROYECT}/customers/${idCustomer}/accounts`;
  const urlPut = `${process.env.REACT_APP_URL}${PROYECT}/customers/${idCustomer}/accounts/${idAccount}`;
  try {
    const fnForm = isEdit ? api_put : api_post;
    const url = isEdit ? urlPut : urlPost;
    const response = yield call(fnForm, url, body, auth);
    yield put({
      type: types.SUCCESS_ACCOUNT,
      payload: { account: response, isEdit },
    });
    yield put(openSnackbar("Cuenta generada con éxito.", "success"));
  } catch (message) {
    yield put({
      type: types.ERROR_ACCOUNT,
    });
    yield put(openSnackbar(message, "danger"));
  }
}
function* sendOrder(action) {
  const token = yield select((state) => state.login.token);
  const { body } = action.payload;
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/services`;
  try {
    const response = yield call(api_post, url, body, auth);

    yield put({
      type: types.SUCCESS_ORDER,
      payload: {
        service: response,
      },
    });
    yield put(openSnackbar("Pedido generdado con éxito.", "success"));
  } catch (message) {
    yield put({
      type: types.ERROR_ORDER,
    });
    yield put(openSnackbar(message, "danger"));
  }
}

function* fetchCustomer(action){

  const token = yield select((state) => state.login.token);
  const { id } = action
  const auth = { headers: { authorization: `${token}` } };
  const urlCustomer = `${ process.env.REACT_APP_URL }${ PROYECT }/customers/${ id }`
  try {
    const response = yield call(api_get, urlCustomer, auth);
    yield put({
      type: types.SET_CUSTOMER_FETCH,
      payload: {
        customer: response[0],
      },
    });   
  } catch (msj) {
    yield put({
      type: types.ERROR_CUSTOMERS,
    });
    let message = msj ? msj : "Cliente no encontrado."
    yield put(openSnackbar(message, "danger"));
  }

}

export function* crmSaga() {
  yield takeLatest(types.LOAD_STATIONS, fetchStations);
  yield takeLatest(types.LOAD_CUSTOMERS, fetchData);
  yield takeLatest(types.LOAD_MENU_DATA, fetchMenuData);
  yield takeLatest(types.LOAD_ORDERS, fetchCustomerOrders);
  yield takeLatest(types.SEND_CUSTOMER, sendCustomer);
  yield takeLatest(types.SEND_ACCOUNT, sendAccount);
  yield takeLatest(types.SEND_ORDER, sendOrder);
  yield takeLatest(types.LOAD_CUSTOMER, fetchCustomer);

}
